/* eslint-disable @typescript-eslint/naming-convention */
import analyticsService from '@razorpay/universe-utils/analytics';

class Analytics {
  private meta: Record<string, string | null | undefined> = {};

  /**
   * Function to set meta data
   * @param key The key for the meta data
   * @param value The value for the meta data
   */
  setMeta(key: string, value: string | null | undefined): void {
    this.meta[key] = value;
  }

  /**
   * Function to get meta data
   * @param key The key for the meta data
   * @returns The value for the meta data
   */
  getMeta(key: string): string | null | undefined {
    return this.meta[key];
  }

  /**
   * Function to remove meta data
   * @param key The key for the meta data
   */
  removeMeta(key: string): void {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this.meta[key];
  }

  /**
   * Initializes the analytics service
   */
  initialize({
    lumberjackApiUrl,
    lumberjackApiKey,
  }: {
    lumberjackApiUrl: string;
    lumberjackApiKey: string;
  }): void {
    analyticsService.init({
      lumberjackAppName: 'flash-credit',
      lumberjackApiUrl,
      lumberjackApiKey,
      segmentApiKey: null as unknown as string,
    });
  }

  /**
   * Function to track analytics events
   */
  track({ actionName, objectName, properties, screen }: analyticsService.TrackProps): void {
    analyticsService
      .track({
        actionName,
        objectName,
        properties: {
          ...properties,
          ...this.meta,
        },
        screen,
      })
      .catch(() => null);
  }
}

const analytics = new Analytics();

export default analytics;
